// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_INPUT,
    value
});

export const updateTransferApprovalFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEM
});

export const toggleTransferApprovalFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_TRANSFER_RECOMMENDATION_FACET_ITEMS
});

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD
        });

    };



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/facets.js